import { render, staticRenderFns } from "./leave_summary.vue?vue&type=template&id=436d6c76&scoped=true"
import script from "./leave_summary.vue?vue&type=script&lang=js"
export * from "./leave_summary.vue?vue&type=script&lang=js"
import style0 from "./leave_summary.vue?vue&type=style&index=0&id=436d6c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d6c76",
  null
  
)

export default component.exports